import React from 'react'
import { Typography } from '@telavita-core/react-design-kit'
import { RadioButton } from 'components'

import * as S from './styles'

type Gender = 'ALL' | 'FEM' | 'MAS'
type GenderLabel = 'Todos' | 'Feminino' | 'Masculino'

interface ProfessionalGenderFilter {
  selectedGender: Gender
  onChangeGender: (code: Gender) => void
}

interface GenderRadioButtonProps {
  code: string
  label: string
  onChangeGender: (code: Gender) => void
  selectedGender: string
}

interface AvailableGenders {
  label: GenderLabel
  code: Gender
}

const availableGenders: AvailableGenders[] = [
  { label: 'Todos', code: 'ALL' },
  { label: 'Feminino', code: 'FEM' },
  { label: 'Masculino', code: 'MAS' },
]

const GenderRadioButton = ({ code, label, onChangeGender, selectedGender }: GenderRadioButtonProps) => {
  return (
    <RadioButton
      radioId={code}
      selected={selectedGender === code}
      value={code}
      onClickRadioButton={() => onChangeGender(code as Gender)}
      iconWidth='20px'
      iconHeight='20px'
      title={label}
    />
  )
}
 
export const ProfessionalGenderFilter: React.FC<ProfessionalGenderFilter> = ({
  onChangeGender,
  selectedGender,
}) => {
  return (
    <S.GenderContainer>
      <Typography variant='content2' weight='bold'>
        Gênero do profissional
      </Typography>
      <S.GenderRadioButtons>
        {availableGenders.map(({code, label}) => (
          <GenderRadioButton
            key={code}
            code={code} 
            label={label} 
            onChangeGender={onChangeGender} 
            selectedGender={selectedGender} 
          />
        ))}
      </S.GenderRadioButtons>
    </S.GenderContainer>
  )
}